import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useRef } from "react";

const DrawingManagerPolygonEditor = ({ onCreate }) => {
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");
  const mapLibMaps = useMapsLibrary("maps");
  const mapLibMarker = useMapsLibrary("marker");
  const mapLibGeometry = useMapsLibrary("geometry");
  const polygonRef = useRef(null);
  const nextLineRef = useRef(null);
  // const isDrawing = useRef(false);
  // const center = useRef(null);
  // const centerMarkerRef = useRef(null);
  // const radiusMarkerRef = useRef(null);

  // const map = useMap();
  // const polygonRef = useRef(null);
  const tempPath = useRef([]);
  // const vertexMarkers = useRef([]);

  useEffect(() => {
    if (!map || !mapLibCore || !mapLibMaps || !mapLibMarker || !mapLibGeometry)
      return;

    let clickListener, dblClickListener, mousemoveListener;

    clickListener = map.addListener("click", (e) => {
      console.log("click", e);
      tempPath.current.push(e.latLng);

      if (!polygonRef.current) {
        // polygonRef.current = new mapLibMaps.Polygon({
        //   map,
        //   paths: tempPath.current,
        //   strokeColor: "#1976D2",
        //   strokeWeight: 2,
        //   fillColor: null, // "#1976D2",
        //   fillOpacity: null,
        //   editable: true,
        //   draggable: false,
        //   clickable: true,
        //   type: "polygon",
        // });
        polygonRef.current = new mapLibMaps.Polyline({
          map,
          path: tempPath,
          geodesic: true,
          strokeColor: "#1976D2",
          strokeOpacity: 1.0,
          strokeWeight: 3,
          editable: true,
          draggable: false,
          clickable: true,
          type: "polygon",
          //           // zIndex: 100,
        });

        let mouseUpListener;

        mouseUpListener = polygonRef.current.addListener(
          "mouseup",
          (polyMouseEvent) => {
            console.log("mouseup", polyMouseEvent);
            if (
              polyMouseEvent.vertex !== undefined &&
              polyMouseEvent.vertex === 0
            ) {
              if (onCreate) {
                onCreate(
                  new mapLibMaps.Polygon({
                    // map,
                    paths: tempPath.current,
                    strokeColor: "#1976D2",
                    strokeWeight: 2,
                    fillColor: "#1976D2",
                    fillOpacity: 0.2,
                    geodesic: true,
                    // editable: true,
                    // draggable: false,
                    // clickable: true,
                    type: "polygon",
                  })
                );

                mapLibCore.event.removeListener(mouseUpListener);
                polygonRef.current.setMap(null);
                polygonRef.current = undefined;
                if (nextLineRef.current) {
                  nextLineRef.current.setMap(null);
                  nextLineRef.current = undefined;
                }
              }
            }
          }
        );
      } else {
        polygonRef.current.setPath(tempPath.current);
      }
    });

    mousemoveListener = map.addListener("mousemove", (e) => {
      if (polygonRef.current) {
        if (!nextLineRef.current) {
          nextLineRef.current = new mapLibMaps.Polyline({
            map,
            // path: tempPath,
            geodesic: true,
            strokeColor: "#1976D2",
            strokeOpacity: 1.0,
            strokeWeight: 3,
            editable: false,
            draggable: false,
            clickable: false,
          });
        }
        nextLineRef.current.setPath(
          [
            tempPath.current.findLast(() => {
              return true;
            }),
          ].concat([e.latLng])
        );
      }
    });

    dblClickListener = map.addListener("dblclick", () => {
      map.setOptions({ draggable: true });
      if (!polygonRef.current) return;

      // Create draggable vertex markers
      // polygonRef.current.getPath().forEach((latLng, i) => {
      //   const div = document.createElement("div");
      //   div.style.width = "10px";
      //   div.style.height = "10px";
      //   div.style.border = "2px solid white";
      //   div.style.borderRadius = "50%";
      //   div.style.background = "#1976D2";

      //   const marker = new mapLibMarker.AdvancedMarkerElement({
      //     map,
      //     position: latLng,
      //     content: div,
      //     gmpDraggable: true,
      //   });

      //   marker.addListener("drag", (ev) => {
      //     const path = polygonRef.current.getPath();
      //     path.setAt(i, ev.latLng);
      //   });

      //   vertexMarkers.current.push(marker);
      // });

      mapLibCore.event.removeListener(clickListener);
      mapLibCore.event.removeListener(dblClickListener);
    });

    return () => {
      if (clickListener) mapLibCore.event.removeListener(clickListener);
      if (mousemoveListener) mapLibCore.event.removeListener(mousemoveListener);
      if (dblClickListener) mapLibCore.event.removeListener(dblClickListener);
      if (polygonRef.current) polygonRef.current.setMap(null);
      // vertexMarkers.current.forEach((m) => (m.map = null));
      if (nextLineRef.current) {
        nextLineRef.current.setMap(null);
        nextLineRef.current = undefined;
      }
    };
  }, [mapLibCore, mapLibMarker, mapLibMaps, mapLibGeometry]);

  return null;

  // useEffect(() => {
  //   if (!map || !mapLibCore || !mapLibMaps || !mapLibMarker || !mapLibGeometry)
  //     return;

  //   let mouseUpListener;

  //   mouseUpListener = map.addListener("mouseup", () => {
  //     console.log("mouseup");
  //     if (isDrawing.current) {
  //       isDrawing.current = false;
  //       map.setOptions({ draggable: true });
  //       if (onCreate) {
  //         onCreate(circleRef.current);
  //       }
  //     }
  //     else {
  //       isDrawing.current = true;
  //       polygonRef.current = new mapLibMaps.Polygon({
  //         map,
  //         paths:
  //       })
  //     }
  //   });

  //   return () => {
  //     console.log("cleanup");

  //     try {
  //       mapLibCore.event.removeListener(mouseDownListener);
  //       mapLibCore.event.removeListener(mouseMoveListener);
  //       mapLibCore.event.removeListener(mouseUpListener);
  //       // if (circleRef.current) circleRef.current.setMap(null);
  //       // if (radiusMarkerRef.current) radiusMarkerRef.current.map = null;
  //     } catch (error) {}
  //   };
  // }, [mapLibCore, mapLibMarker, mapLibMaps, mapLibGeometry]);

  // return null;
};

export default DrawingManagerPolygonEditor;
